import { Link } from "react-router-dom";
import logo from "../../assets/images/logo_white.png";
import { useContext, useState } from "react";
import { AuthContext } from "../../contexts/AuthContext";
import Profile from "./Header/components/Profile";
import { LoginOutlined } from "@ant-design/icons";
import { Button } from "antd";
import UploadVehicles from "../../pages/home/components/UploadVehicles";
import { Upload } from "lucide-react";

export default function Header() {
  const { token } = useContext(AuthContext);
  const [isVisible, setVisible] = useState(false);
  const [uploadModal, setUploadModal] = useState<boolean>(false);
  return (
    <div className="h-14 bg-toyota pt-3">
      <div className="flex flex-row justify-between items-center px-5 max-w-7xl mx-auto">
        <div className="flex flex-row items-center  ">
          <Link
            to="/"
            className="flex justify-center items-center border-gray-400 pr-4"
          >
            <img src={logo} alt="Logo" height={15} width={50} />
          </Link>
          <div className="text-white text-xs gap-x-1 flex flex-col">
            <div className="flex flex-row items-center">
              <span className="font-bold">TOYOTA TANZANIA LTD</span>
            </div>
            <div className="flex flex-row items-center">
              <span
                className="font-thin"
                style={{ fontSize: 8, letterSpacing: 2 }}
              >
                2ND KEY PROGRAMMING
              </span>
            </div>
          </div>
        </div>

        <div className="flex flex-row items-center gap-x-2">
          <div className="">
            <Button type="primary" danger onClick={() => setUploadModal(true)}>
              <Upload size={16} />
            </Button>
          </div>
          {token ? (
            <div className="z-50">
              <Profile isVisible={isVisible} setVisible={setVisible} />
            </div>
          ) : (
            <Link
              to={"/"}
              className="mx-4 flex justify-center items-center text-white rounded-md py-1"
            >
              <LoginOutlined color="#FFFFFF" size={22} />
            </Link>
          )}
        </div>
        {uploadModal && (
          <UploadVehicles isVisible={uploadModal} setVisible={setUploadModal} />
        )}
      </div>
    </div>
  );
}
